import JoinAppointment from './JoinAppointment'
import Messages from './Messages'

export default function Notifications() {
  return (
    <>
      <Messages />
      <JoinAppointment />
    </>
  )
}
